import React from 'react';

import { FieldHint } from './FieldHint';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
  /** Optional element rendered inside the field on the right (e.g. an action icon). */
  rightAdornment?: React.ReactNode;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  hint,
  rightAdornment,
  className = '',
  id,
  ...props
}) => {
  // Generate unique ID for label association
  const inputId = id || `input-${React.useId()}`;

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={inputId} className="block text-neutral-700 mb-1.5" style={{
          fontFamily: 'Oxygen',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '20px'
        }}>
          {label}
        </label>
      )}
      <div className="relative">
        <input
          id={inputId}
          className={`w-full px-3 py-2 border rounded-lg text-base transition-colors ${
            rightAdornment ? 'pr-10' : ''
          } ${
            error
              ? 'border-error-500 focus:ring-error-500'
              : 'border-neutral-300 focus:ring-primary-500'
          } focus:outline-none focus:ring-2 focus:ring-inset ${className}`}
          {...props}
        />
        {rightAdornment && (
          <div className="absolute inset-y-0 right-2 flex items-center">{rightAdornment}</div>
        )}
      </div>
      {error && <p className="text-error-500 text-sm mt-1">{error}</p>}
      {hint && !error && <FieldHint>{hint}</FieldHint>}
    </div>
  );
};

export default Input;
